import Dbm from "dbm";
import Website from "../../index.js";

//import * as PIXI from "pixi.js";
//import Matter from "matter-js";

export default class PreGameOver extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        this.item.requireProperty("game", null);

        let layer = new PIXI.Container()
        this.item.requireProperty("pixiLayer", layer);
    }

    prepare() {
        //console.log("prepare");

        const box = new PIXI.Graphics();
        box.beginFill(0x000000);
        box.drawRect(0, 0, Website.game.Sizes.WIDTH, Website.game.Sizes.HEIGHT);
        box.endFill();
        this.item.pixiLayer.addChild(box);


        {
            let text = Dbm.getRepositoryItem("game").controller.getText("På Byråkratimyndighetsverket...", 16, 0xFFFFFF);
        
            text.position.x = 0.5*(Website.game.Sizes.WIDTH-text.width);
            text.position.y = 0.5*(Website.game.Sizes.HEIGHT-text.height);

            this.item.pixiLayer.addChild(text);
        }
        
        let scoreDisplay = new Website.game.gameplay.graphics.ScoreDisplay();
        this.item.pixiLayer.addChild(scoreDisplay.item.pixiLayer);
        this.item.setValue("scoreDisplay", scoreDisplay.item);
    }

    start() {
        this.item.scoreDisplay.score = this.item.game.score;

        setTimeout(() => {
            this.item.game.controller.changeScreen("gameOver");
        }, 1.5*1000);
    }

    update() {
        let time = this.item.game.timer.time;
        let deltaTime = this.item.game.timer.delta;

        this.item.scoreDisplay.controller.update(time, deltaTime);
    }

    stop() {
        
    }
}